module.exports = __webpack_public_path__ + "img/procedure.0f7db2c4.png";